<template>
  <div class="container col-md-12">
    <h1>State Tax Calc</h1>
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>

    <div v-if="calcData">
      <hr />
      <h3>Result</h3>
      <md-content>
        <md-content class="md-padding">
          <md-tabs md-dynamic-height md-border-bottom>
            <md-tab md-label="No Pre-Tax Contributions">
              <md-content class="md-padding">
                <div class="md-layout">
                  <div class="md-layout-item" style="margin-right: 20px">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="4" scope="colgroup">Inputs</th>
                      </tr>
                      <tr>
                        <th>State</th>
                        <td>{{ calcData.current_income_no_pre_tax.state }}</td>
                      </tr>
                      <tr>
                        <th>Filing Status</th>
                        <td>{{ calcData.participant.marital_status }}</td>
                      </tr>
                      <tr>
                        <th>Wages</th>
                        <td>
                          {{
                            calcData.participant.estimated_annual_wages
                              | currency
                          }}
                        </td>
                      </tr>
                      <!--<tr>-->
                      <!--<th>Federal Deduction</th>-->
                      <!--<td>{{calcData.current_income_no_pre_tax.federal_deduction | currency}}</td>-->
                      <!--</tr>-->
                      <tr>
                        <th>Standard Deduction</th>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax
                              .standard_deduction | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Personal Deduction</th>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax
                              .personal_deduction | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Pre-Tax Contributions</th>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax
                              .pre_tax_contributions | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Taxable Income</th>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax.taxable_income
                              | currency
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="md-layout-item">
                    <table class=" table table-striped table-bordered">
                      <tr>
                        <th colspan="4" scope="colgroup">Outputs</th>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax.income_tax
                              .bracket | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 1</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 2</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax.tax_amount
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Amount</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax
                              .final_state_tax_amount | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Rate</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax
                              .final_state_tax_rate | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>State</td>
                        <td>{{ calcData.current_income_no_pre_tax.state }}</td>
                      </tr>
                      <tr>
                        <td>Wages</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax.income_tax.wages
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax.income_tax
                              .bracket | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.current_income_no_pre_tax.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th>State</th>
                        <th>#</th>
                        <th>Bracket</th>
                        <th>Max Value</th>
                        <th>Tax</th>
                        <th>Rate</th>
                      </tr>
                      <tr
                        v-for="income_tax in calcData.current_income_no_pre_tax
                          .income_tax.rows"
                      >
                        <td>{{ calcData.current_income_no_pre_tax.state }}</td>
                        <td>{{ income_tax.number }}</td>
                        <td>{{ income_tax.bracket | currency }}</td>
                        <td>{{ income_tax.max_value | currency }}</td>
                        <td>{{ income_tax.tax | currency }}</td>
                        <td>{{ income_tax.rate | numeral("0.2") }}%</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </md-content>
            </md-tab>
            <md-tab md-label="WITH Pre-Tax Contributions">
              <md-content class="md-padding">
                <div class="md-layout">
                  <div class="md-layout-item" style="margin-right: 20px">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="4" scope="colgroup">Inputs</th>
                      </tr>
                      <tr>
                        <th>State</th>
                        <td>{{ calcData.current_income_pre_tax.state }}</td>
                      </tr>
                      <tr>
                        <th>Filing Status</th>
                        <td>{{ calcData.participant.marital_status }}</td>
                      </tr>
                      <tr>
                        <th>Wages</th>
                        <td>
                          {{
                            calcData.participant.estimated_annual_wages
                              | currency
                          }}
                        </td>
                      </tr>
                      <!--<tr>-->
                      <!--<th>Federal Deduction</th>-->
                      <!--<td>{{calcData.current_income_pre_tax.federal_deduction | currency}}</td>-->
                      <!--</tr>-->
                      <tr>
                        <th>Standard Deduction</th>
                        <td>
                          {{
                            calcData.current_income_pre_tax.standard_deduction
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Personal Deduction</th>
                        <td>
                          {{
                            calcData.current_income_pre_tax.personal_deduction
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Pre-Tax Contributions</th>
                        <td>
                          {{
                            calcData.current_income_pre_tax
                              .pre_tax_contributions | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Taxable Income</th>
                        <td>
                          {{
                            calcData.current_income_pre_tax.taxable_income
                              | currency
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="4" scope="colgroup">Outputs</th>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 1</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 2</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax.tax_amount
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Amount</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax
                              .final_state_tax_amount | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Rate</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax
                              .final_state_tax_rate | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>State</td>
                        <td>{{ calcData.current_income_pre_tax.state }}</td>
                      </tr>
                      <tr>
                        <td>Wages</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax.income_tax.wages
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.current_income_pre_tax.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th>State</th>
                        <th>#</th>
                        <th>Bracket</th>
                        <th>Max Value</th>
                        <th>Tax</th>
                        <th>Rate</th>
                      </tr>
                      <tr
                        v-for="income_tax in calcData.current_income_pre_tax
                          .income_tax.rows"
                      >
                        <td>{{ calcData.current_income_pre_tax.state }}</td>
                        <td>{{ income_tax.number }}</td>
                        <td>{{ income_tax.bracket | currency }}</td>
                        <td>{{ income_tax.max_value | currency }}</td>
                        <td>{{ income_tax.tax | currency }}</td>
                        <td>{{ income_tax.rate | numeral("0.2") }}%</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </md-content>
            </md-tab>
            <md-tab md-label="LDI Fund A">
              <md-content class="md-padding">
                <div class="md-layout">
                  <div class="md-layout-item" style="margin-right: 20px">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="2" scope="colgroup">Inputs</th>
                        <th>State Tax Factor</th>
                        <th>Ret Income</th>
                      </tr>
                      <tr>
                        <th>State</th>
                        <td>{{ calcData.retirement_income_ldi_a.state }}</td>
                      </tr>
                      <tr>
                        <th>Filing Status</th>
                        <td>{{ calcData.participant.marital_status }}</td>
                      </tr>
                      <tr>
                        <th>Retirement Age</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.retirement_age
                              | numeral("0.1")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Social Security</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.social_security
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.social_security
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.social_security
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_pre_tax.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_pre_tax.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Post-Tax TAXABLE</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_post_tax_taxable
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_post_tax_taxable
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_post_tax_taxable
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Rollover</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_rollover.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_rollover
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_rollover
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Match</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_er_match.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_er_match
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_er_match
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Other</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_er_other.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_er_other
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.dc_er_other
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>NQDC</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.nqdc.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.nqdc.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.nqdc.ret_income
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.other_pre_tax
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.other_pre_tax
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.other_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Sponsor DB</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.sponsor_db.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.sponsor_db.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.sponsor_db
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pension</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.other_pension
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.other_pension
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.other_pension
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <!--<tr>-->
                      <!--<th>Federal Std Deduction</th>-->
                      <!--<td>{{ calcData.retirement_income_ldi_a.federal_deduction.income | currency }}</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_a.federal_deduction.percent | numeral("0.0") }}%</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_a.federal_deduction.ret_income | currency }}</td>-->
                      <!--</tr>-->
                      <tr>
                        <th>Beginning State Income</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.state_income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.standard_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.standard_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>State Pers Deduction</th>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.personal_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.personal_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td></td>
                        <td>EXEMPTION</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.exemption
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.taxable_income
                              | currency
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="4" scope="colgroup">Outputs</th>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 1</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 2</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.tax_amount
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Amount</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a
                              .final_state_tax_amount | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a
                              .final_state_tax_rate | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>State</td>
                        <td>{{ calcData.retirement_income_ldi_a.state }}</td>
                      </tr>
                      <tr>
                        <td>Wages</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.income_tax.wages
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_a.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th>State</th>
                        <th>#</th>
                        <th>Bracket</th>
                        <th>Max Value</th>
                        <th>Tax</th>
                        <th>Rate</th>
                      </tr>
                      <tr
                        v-for="income_tax in calcData.retirement_income_ldi_a
                          .income_tax.rows"
                      >
                        <td>{{ calcData.retirement_income_ldi_a.state }}</td>
                        <td>{{ income_tax.number }}</td>
                        <td>{{ income_tax.bracket | currency }}</td>
                        <td>{{ income_tax.max_value | currency }}</td>
                        <td>{{ income_tax.tax | currency }}</td>
                        <td>{{ income_tax.rate | numeral("0.2") }}%</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </md-content>
            </md-tab>
            <md-tab md-label="LDI Fund B">
              <md-content class="md-padding">
                <div class="md-layout">
                  <div class="md-layout-item" style="margin-right: 20px">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="2" scope="colgroup">Inputs</th>
                        <th>State Tax Factor</th>
                        <th>Ret Income</th>
                      </tr>
                      <tr>
                        <th>State</th>
                        <td>{{ calcData.retirement_income_ldi_b.state }}</td>
                      </tr>
                      <tr>
                        <th>Filing Status</th>
                        <td>{{ calcData.participant.marital_status }}</td>
                      </tr>
                      <tr>
                        <th>Retirement Age</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.retirement_age
                              | numeral("0.1")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Social Security</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.social_security
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.social_security
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.social_security
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_pre_tax.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_pre_tax.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Post-Tax TAXABLE</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_post_tax_taxable
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_post_tax_taxable
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_post_tax_taxable
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Rollover</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_rollover.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_rollover
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_rollover
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Match</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_er_match.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_er_match
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_er_match
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Other</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_er_other.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_er_other
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.dc_er_other
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>NQDC</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.nqdc.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.nqdc.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.nqdc.ret_income
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.other_pre_tax
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.other_pre_tax
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.other_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Sponsor DB</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.sponsor_db.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.sponsor_db.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.sponsor_db
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pension</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.other_pension
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.other_pension
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.other_pension
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <!--<tr>-->
                      <!--<th>Federal Std Deduction</th>-->
                      <!--<td>{{ calcData.retirement_income_ldi_b.federal_deduction.income | currency }}</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_b.federal_deduction.percent | numeral("0.0") }}%</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_b.federal_deduction.ret_income | currency }}</td>-->
                      <!--</tr>-->
                      <tr>
                        <th>Beginning State Income</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.state_income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.standard_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.standard_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>State Pers Deduction</th>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.personal_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.personal_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td></td>
                        <td>EXEMPTION</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.exemption
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.taxable_income
                              | currency
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="4" scope="colgroup">Outputs</th>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 1</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 2</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.tax_amount
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Amount</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b
                              .final_state_tax_amount | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b
                              .final_state_tax_rate | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>State</td>
                        <td>{{ calcData.retirement_income_ldi_b.state }}</td>
                      </tr>
                      <tr>
                        <td>Wages</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.income_tax.wages
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_b.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th>State</th>
                        <th>#</th>
                        <th>Bracket</th>
                        <th>Max Value</th>
                        <th>Tax</th>
                        <th>Rate</th>
                      </tr>
                      <tr
                        v-for="income_tax in calcData.retirement_income_ldi_b
                          .income_tax.rows"
                      >
                        <td>{{ calcData.retirement_income_ldi_b.state }}</td>
                        <td>{{ income_tax.number }}</td>
                        <td>{{ income_tax.bracket | currency }}</td>
                        <td>{{ income_tax.max_value | currency }}</td>
                        <td>{{ income_tax.tax | currency }}</td>
                        <td>{{ income_tax.rate | numeral("0.2") }}%</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </md-content>
            </md-tab>
            <md-tab md-label="LDI Fund C">
              <md-content class="md-padding">
                <div class="md-layout">
                  <div class="md-layout-item" style="margin-right: 20px">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="2" scope="colgroup">Inputs</th>
                        <th>State Tax Factor</th>
                        <th>Ret Income</th>
                      </tr>
                      <tr>
                        <th>State</th>
                        <td>{{ calcData.retirement_income_ldi_c.state }}</td>
                      </tr>
                      <tr>
                        <th>Filing Status</th>
                        <td>{{ calcData.participant.marital_status }}</td>
                      </tr>
                      <tr>
                        <th>Retirement Age</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.retirement_age
                              | numeral("0.1")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Social Security</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.social_security
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.social_security
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.social_security
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_pre_tax.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_pre_tax.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Post-Tax TAXABLE</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_post_tax_taxable
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_post_tax_taxable
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_post_tax_taxable
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Rollover</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_rollover.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_rollover
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_rollover
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Match</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_er_match.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_er_match
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_er_match
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Other</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_er_other.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_er_other
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.dc_er_other
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>NQDC</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.nqdc.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.nqdc.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.nqdc.ret_income
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.other_pre_tax
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.other_pre_tax
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.other_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Sponsor DB</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.sponsor_db.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.sponsor_db.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.sponsor_db
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pension</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.other_pension
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.other_pension
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.other_pension
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <!--<tr>-->
                      <!--<th>Federal Std Deduction</th>-->
                      <!--<td>{{ calcData.retirement_income_ldi_c.federal_deduction.income | currency }}</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_c.federal_deduction.percent | numeral("0.0") }}%</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_c.federal_deduction.ret_income | currency }}</td>-->
                      <!--</tr>-->
                      <tr>
                        <th>Beginning State Income</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.state_income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.standard_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.standard_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>State Pers Deduction</th>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.personal_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.personal_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td></td>
                        <td>EXEMPTION</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.exemption
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.taxable_income
                              | currency
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="4" scope="colgroup">Outputs</th>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 1</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 2</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.tax_amount
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Amount</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c
                              .final_state_tax_amount | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c
                              .final_state_tax_rate | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>State</td>
                        <td>{{ calcData.retirement_income_ldi_c.state }}</td>
                      </tr>
                      <tr>
                        <td>Wages</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.income_tax.wages
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_c.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th>State</th>
                        <th>#</th>
                        <th>Bracket</th>
                        <th>Max Value</th>
                        <th>Tax</th>
                        <th>Rate</th>
                      </tr>
                      <tr
                        v-for="income_tax in calcData.retirement_income_ldi_c
                          .income_tax.rows"
                      >
                        <td>{{ calcData.retirement_income_ldi_c.state }}</td>
                        <td>{{ income_tax.number }}</td>
                        <td>{{ income_tax.bracket | currency }}</td>
                        <td>{{ income_tax.max_value | currency }}</td>
                        <td>{{ income_tax.tax | currency }}</td>
                        <td>{{ income_tax.rate | numeral("0.2") }}%</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </md-content>
            </md-tab>
            <md-tab md-label="LDI Fund D">
              <md-content class="md-padding">
                <div class="md-layout">
                  <div class="md-layout-item" style="margin-right: 20px">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="2" scope="colgroup">Inputs</th>
                        <th>State Tax Factor</th>
                        <th>Ret Income</th>
                      </tr>
                      <tr>
                        <th>State</th>
                        <td>{{ calcData.retirement_income_ldi_d.state }}</td>
                      </tr>
                      <tr>
                        <th>Filing Status</th>
                        <td>{{ calcData.participant.marital_status }}</td>
                      </tr>
                      <tr>
                        <th>Retirement Age</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.retirement_age
                              | numeral("0.1")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Social Security</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.social_security
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.social_security
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.social_security
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_pre_tax.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_pre_tax.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Post-Tax TAXABLE</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_post_tax_taxable
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_post_tax_taxable
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_post_tax_taxable
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Rollover</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_rollover.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_rollover
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_rollover
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Match</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_er_match.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_er_match
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_er_match
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Other</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_er_other.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_er_other
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.dc_er_other
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>NQDC</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.nqdc.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.nqdc.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.nqdc.ret_income
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.other_pre_tax
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.other_pre_tax
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.other_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Sponsor DB</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.sponsor_db.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.sponsor_db.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.sponsor_db
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pension</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.other_pension
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.other_pension
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.other_pension
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <!--<tr>-->
                      <!--<th>Federal Std Deduction</th>-->
                      <!--<td>{{ calcData.retirement_income_ldi_d.federal_deduction.income | currency }}</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_d.federal_deduction.percent | numeral("0.0") }}%</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_d.federal_deduction.ret_income | currency }}</td>-->
                      <!--</tr>-->
                      <tr>
                        <th>Beginning State Income</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.state_income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.standard_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.standard_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>State Pers Deduction</th>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.personal_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.personal_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td></td>
                        <td>EXEMPTION</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.exemption
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.taxable_income
                              | currency
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="4" scope="colgroup">Outputs</th>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 1</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 2</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.tax_amount
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Amount</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d
                              .final_state_tax_amount | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d
                              .final_state_tax_rate | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>State</td>
                        <td>{{ calcData.retirement_income_ldi_d.state }}</td>
                      </tr>
                      <tr>
                        <td>Wages</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.income_tax.wages
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_d.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th>State</th>
                        <th>#</th>
                        <th>Bracket</th>
                        <th>Max Value</th>
                        <th>Tax</th>
                        <th>Rate</th>
                      </tr>
                      <tr
                        v-for="income_tax in calcData.retirement_income_ldi_d
                          .income_tax.rows"
                      >
                        <td>{{ calcData.retirement_income_ldi_d.state }}</td>
                        <td>{{ income_tax.number }}</td>
                        <td>{{ income_tax.bracket | currency }}</td>
                        <td>{{ income_tax.max_value | currency }}</td>
                        <td>{{ income_tax.tax | currency }}</td>
                        <td>{{ income_tax.rate | numeral("0.2") }}%</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </md-content>
            </md-tab>
            <md-tab md-label="LDI Fund E">
              <md-content class="md-padding">
                <div class="md-layout">
                  <div class="md-layout-item" style="margin-right: 20px">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="2" scope="colgroup">Inputs</th>
                        <th>State Tax Factor</th>
                        <th>Ret Income</th>
                      </tr>
                      <tr>
                        <th>State</th>
                        <td>{{ calcData.retirement_income_ldi_e.state }}</td>
                      </tr>
                      <tr>
                        <th>Filing Status</th>
                        <td>{{ calcData.participant.marital_status }}</td>
                      </tr>
                      <tr>
                        <th>Retirement Age</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.retirement_age
                              | numeral("0.1")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Social Security</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.social_security
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.social_security
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.social_security
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_pre_tax.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_pre_tax.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Post-Tax TAXABLE</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_post_tax_taxable
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_post_tax_taxable
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_post_tax_taxable
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Rollover</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_rollover.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_rollover
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_rollover
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Match</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_er_match.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_er_match
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_er_match
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>DC Employer Other</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_er_other.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_er_other
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.dc_er_other
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>NQDC</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.nqdc.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.nqdc.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.nqdc.ret_income
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pre-Tax</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.other_pre_tax
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.other_pre_tax
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.other_pre_tax
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Sponsor DB</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.sponsor_db.income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.sponsor_db.percent
                              | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.sponsor_db
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Other Pension</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.other_pension
                              .income | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.other_pension
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.other_pension
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <!--<tr>-->
                      <!--<th>Federal Std Deduction</th>-->
                      <!--<td>{{ calcData.retirement_income_ldi_e.federal_deduction.income | currency }}</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_e.federal_deduction.percent | numeral("0.0") }}%</td>-->
                      <!--<td>{{ calcData.retirement_income_ldi_e.federal_deduction.ret_income | currency }}</td>-->
                      <!--</tr>-->
                      <tr>
                        <th>Beginning State Income</th>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.state_income
                              | currency
                          }}
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.standard_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.standard_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>State Pers Deduction</th>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.personal_deduction
                              .percent | numeral("0.0")
                          }}%
                        </td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.personal_deduction
                              .ret_income | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td></td>
                        <td>EXEMPTION</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.exemption
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.taxable_income
                              | currency
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th colspan="4" scope="colgroup">Outputs</th>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 1</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount 2</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.tax_amount
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Amount</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e
                              .final_state_tax_amount | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Final State Tax Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e
                              .final_state_tax_rate | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>State</td>
                        <td>{{ calcData.retirement_income_ldi_e.state }}</td>
                      </tr>
                      <tr>
                        <td>Wages</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.income_tax.wages
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>.</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Bracket Starting Point</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.income_tax.bracket
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.income_tax.tax
                              | currency
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Rate</td>
                        <td>
                          {{
                            calcData.retirement_income_ldi_e.income_tax.rate
                              | numeral("0.2")
                          }}%
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="md-layout-item">
                    <table class="table table-striped table-bordered">
                      <tr>
                        <th>State</th>
                        <th>#</th>
                        <th>Bracket</th>
                        <th>Max Value</th>
                        <th>Tax</th>
                        <th>Rate</th>
                      </tr>
                      <tr
                        v-for="income_tax in calcData.retirement_income_ldi_e
                          .income_tax.rows"
                      >
                        <td>{{ calcData.retirement_income_ldi_e.state }}</td>
                        <td>{{ income_tax.number }}</td>
                        <td>{{ income_tax.bracket | currency }}</td>
                        <td>{{ income_tax.max_value | currency }}</td>
                        <td>{{ income_tax.tax | currency }}</td>
                        <td>{{ income_tax.rate | numeral("0.2") }}%</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </md-content>
            </md-tab>
          </md-tabs>
        </md-content>
      </md-content>
    </div>
  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
import RoeCalcInputFields from "@/components/calculators/InputFields";
import store from "@/store";
import { mapGetters } from "vuex";
import { CALC_STATE_TAX, CALC_RESET_STATE } from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
export default {
  data() {
    return {
      calcAction: CALC_STATE_TAX,
      inputCategories: [
        INPUT_TYPES.PARTICIPANT_BALANCE,
        INPUT_TYPES.PARTICIPANT,
        INPUT_TYPES.PLAN_BASIC_DATA,
        INPUT_TYPES.AUTO_ENROLLMENT,
        INPUT_TYPES.AUTO_INCREASE,
        INPUT_TYPES.EMPLOYEE_CONTRIBUTION,
        INPUT_TYPES.EMPLOYEE_MATCH,
        INPUT_TYPES.EMPLOYEE_OTHER,
        INPUT_TYPES.PRE_TAX_CONTRIBUTION,
        INPUT_TYPES.ROTH_CONTRIBUTION,
        INPUT_TYPES.POST_TAX_CONTRIBUTION,
        INPUT_TYPES.NQDC_CONTRIBUTION,
        INPUT_TYPES.COMPLIANCE_LIMIT
      ]
    };
  },
  components: { RoeCalcInputFields },
  computed: {
    ...mapGetters(["calcData"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
